// extracted by mini-css-extract-plugin
export default {"container":"NotFoundPage_container__1dLnP","message_container":"NotFoundPage_message_container__A9pTu","message":"NotFoundPage_message__OuZZb"};